import type { NativeBottomTabNavigationOptions } from '@react-navigation/bottom-tabs/unstable';
import { Platform } from 'react-native';

import { colors } from '../../../core/theme/tokens';
import { GrowTabScreen } from '../screens/GrowTabScreen';
import { HomeTabScreen } from '../screens/HomeTabScreen';
import { LoanTabScreen } from '../screens/LoanTabScreen';
import { WealthTabScreen } from '../screens/WealthTabScreen';
import { MAIN_TAB_META, type MainTabName } from '../../../core/navigation/tabIconConfig';
import { SpendStack } from './SpendStack';

export const MAIN_TABS = (Object.keys(MAIN_TAB_META) as MainTabName[]).map((name) => ({
  name,
  component: {
    Home: HomeTabScreen,
    Spend: SpendStack,
    Wealth: WealthTabScreen,
    Grow: GrowTabScreen,
    Loan: LoanTabScreen,
  }[name],
  label: MAIN_TAB_META[name].label,
  icon: MAIN_TAB_META[name].icon,
}));

export const nativeTabScreenOptions: NativeBottomTabNavigationOptions = {
  headerShown: false,
  tabBarActiveTintColor: colors.accent,
  tabBarInactiveTintColor: colors.tabBarInactive,
  tabBarLabelVisibilityMode: 'labeled',
  ...(Platform.OS === 'ios'
    ? {
        // Dark liquid-glass pill. `none` + missing UIUserInterfaceStyle painted a solid
        // white bar on iOS 26. FAB sits above the pill (`AssistantHost` fabBottom).
        tabBarBlurEffect: 'systemChromeMaterialDark',
        tabBarStyle: { backgroundColor: 'transparent' },
        tabBarMinimizeBehavior: 'never' as const,
      }
    : {
        tabBarStyle: { backgroundColor: colors.background },
      }),
};
